import Box from '@mui/material/Box';
import { useRecoilValue } from 'recoil';
import { selectedPatientIdState } from '~/state/atoms/patientAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import DatasetPicker from '../ContouringStep/DatasetPicker/DatasetPicker';
import StepHeader from '../StepHeader';
import ReviewStructureSet from './ReviewStructureSet/ReviewStructureSet';

export default function ReviewContent() {
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const currentStructureSet = useRecoilValue(currentStructureSetState);

    return (
        selectedPatientId && (
            <Box
                height="100%"
                position="relative"
                display="grid"
                gridTemplateColumns="minmax(0, 1fr)"
            >
                <Box
                    position="relative"
                    display="grid"
                    gridTemplateRows="auto 1fr"
                    gridTemplateColumns="minmax(0, 1fr)"
                >
                    <Box>
                        <StepHeader titleId="workflow.review" />
                        <Box px={2} mt={1}>
                            <DatasetPicker />
                        </Box>
                    </Box>
                    {currentStructureSet && (
                        <Box height="100%" display="grid">
                            <ReviewStructureSet
                                structureSet={currentStructureSet}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        )
    );
}
